<template>
  <div v-if="active"
       class="modal is-active">
    <div class="modal-background"></div>
    <aside class="modal-card"
           qa="auth-modal"
           role="dialog"
           aria-modal="active"
           aria-labelledby="auth-modal"
           tabindex="-1">
      <!-- Modal Trapping Section -->
      <div aria-hidden="true"
           @focus="selectFirstElement()"
           tabindex="0" />
      <!-- Modal Trapping Ends -->
      <button aria-label="To close modal"
              v-if="canClose"
              class="close gtm-login-close cursor-pointer"
              ref="first_element"
              @click="close(false)">
        <i class="fal fa-times" />
      </button>
      <section class="section">
        <div v-if="noMethodSelected">
          <div v-if="$isYSC">
            <span v-if="!showStudentCode" class="title welcome-modal" qa="signup-modal-title">{{ $t("signup-modal.cwsf.title") }}</span>
            <span v-if="showStudentCode" class="title welcome-modal" qa="signup-modal-title">STUDENT REGISTRATION</span>
          </div>
          <div v-else-if="isOhioClassRegistration" class="title welcome-modal" qa="signup-modal-title"><img class="title-img" :src="title"></div>
          <div v-else class="title welcome-modal" qa="signup-modal-title">{{title}}</div>
          <div class="container">
            <div v-if="!showMakeOauth && signUpWelcomeMessage" class="make-login has-account-message">
              {{ signUpWelcomeMessage }}
            </div>
            <p v-if="$isOhioScience && !isOhioStudentRegistration"
               class="has-account-message"
               tabindex="0"
               v-on:keypress.space.enter="showLogin">
              {{ $t("login.haveAccountOAS") }}<a @click="showLogin" qa="login-switch">
              {{ $t("login.login") }}</a>
            </p>
            <div v-if="showMakeOauth" class="make-login has-account-message">
              <span>{{ $t("login.fromMake") }} <a @click="make"><strong>{{ $t("login.make") }}</strong></a>, {{ $t("login.click") }} <a @click="make"><strong>{{ $t("login.here") }}!</strong></a></span>
            </div>
            <div class="signup-inputs" v-if="$isYSC && showStudentCode && !showStudentSignUp" >
              <div class="field full-width">
                <p class="signup center">
                  <Input ref="studentCode"
                         class="signup"
                         :type="'text'"
                         :name="'studentCode'"
                         :value="studentCode"
                         v-model="studentCode"
                         :center="true"
                         :disabled="waiting"
                         :label="enterStudentCode"
                         :autocomplete="'off'"
                         data-lpignore="true" />
                </p>
                <div v-if="error" class="help has-text-danger error">{{error}}</div>
              </div>
              <div class="next-button-container">
                <div class="button is-primary is-full-width continue-button" :class="{'is-loading': waiting}" @click="checkStudentCodeInDB" qa="signup-continue-btn">{{$t('continue') }}</div>
              </div>
            </div>
            <div class="signup-inputs" v-if="$isYSC && showStudentSignUp">
              <div class="field full-width">
                <p class="signup center">
                  <Input ref="studFirstName" class="signup" :type="'text'" :name="'studFirstName'" :value="studFirstName" v-model="studFirstName" :center="true" :disabled="waiting"
                         :label="$t('login.studFirstName')"
                         :autocomplete="'off'"
                         data-lpignore="true" />
                  <Input ref="studLastName" class="signup" :type="'text'" :name="'studLastName'" :value="studLastName" v-model="studLastName" :center="true" :disabled="waiting"
                         :label="$t('login.studLastName')"
                         :autocomplete="'off'"
                         data-lpignore="true" />
                  <Input ref="studUsername" class="signup" :type="'text'" :name="'studUsername'" :value="studUsername" v-model="studUsername" :center="true" :disabled="waiting"
                         :label="$t('login.studUsername')"
                         :autocomplete="'off'"
                         data-lpignore="true" />
                </p>
                <div v-if="error" class="help has-text-danger error">{{error}}</div>
              </div>
              <div class="next-button-container">
                <vue-recaptcha
                    ref="recaptcha"
                    @verify="studentSignUpByCode"
                    @expired="onRecaptchaExpired"
                    size="invisible"
                    :sitekey="recaptcha_sitekey">
                </vue-recaptcha>
                <div class="button is-primary is-full-width continue-button" :class="{'is-loading': waiting}" @click="onRecaptchaButtonClicked" qa="signup-continue-btn">{{$t('next') }}</div>
              </div>
            </div>
            <!-- Need to update here-->
            <div class="signup-inputs" v-if="$isIsef || $isGirlsAndSteam || $isBroadcomMasters || $isSts">
              <Input ref="email" class="signup"
                     :class="{'isef-spacing' : !$isGirlsAndSteam && !$isBroadcomMasters}"
                     :type="'search'" :name="'email'"
                     :value="email"
                     v-model="email"
                     :placeholder="emailPlaceholder"
                     :center="true"
                     @enter="$refs.username.$refs.input.focus()"
                     :disabled="waiting"
                     :label="emailPlaceholder"
                     :autocomplete="'off'"
                     data-lpignore="true" />
              <!-- Username Input -->
              <Input ref="username" class="signup" :type="'search'" :name="'username'" :value="username" v-model.trim="username" :placeholder="usernamePlaceholder" :center="true" @enter="$refs.password.$refs.input.focus()" :disabled="waiting" :label="usernamePlaceholder" :autocomplete="'off'" data-lpignore="true" />
              <!-- Password Input -->
              <Input ref="password" class="signup" :type="'password'" :name="'password'" :value="password" v-model.trim="password" :placeholder="passwordPlaceholder" :center="true" @enter="$refs.confirmedPassword.$refs.input.focus()" :disabled="waiting" :label="passwordPlaceholder" :autocomplete="'new-password'" data-lpignore="true" />
              <!-- Confirm Password Input -->
              <Input ref="confirmedPassword" class="signup" :type="'password'" :name="'confirmedPassword'" :value="password" v-model.trim="confirmedPassword" :placeholder="confirmPasswordPlaceholder" :center="true" @enter="signup" :disabled="waiting" :label="confirmPasswordPlaceholder" />
              <div v-if="error && (!userNotFoundError || !invalidEmailError)" class="help has-text-danger error">{{error}}</div>
              <div v-if="showPasswordError && (!userNotFoundError || !invalidEmailError)" style="text-align: left; padding-top: 0.5rem">
                <ul class="password-check help has-text-danger error">
                  <li :class="{'success': passwordNumberCheck}">{{ $t("password.number")}}</li>
                  <li :class="{'success': passwordUppercaseCheck}">{{ $t("password.upper")}}</li>
                  <li :class="{'success': passwordLengthCheck}">{{ $t("password.length")}}</li>
                  <li :class="{'success': passwordSequencesCheck}">{{ $t("password.seq")}}</li>
                </ul>
              </div>
              <div v-if="!$isGirlsAndSteam"
                   class="left occupation isef-spacing">
                <p class="center"> {{ $t('signup-modal.i-am-a') }} </p>
                <span v-for="job in occupations" :key="job">
                  <input ref="occupation" class="signup" type="radio"  v-model="occupation" :value="job" name="occupation"/> {{job}}<br>
                </span>
              </div>
              <p class="mt-2"> {{ !$isGirlsAndSteam ?
                  $t('signup-modal.eea-age-14-16-student') : $t('signup-modal.eea-under-13-student')}} </p>
              <Input ref="parentEmail isef-spacing"
                     class="signup"
                     :class="{'isef-spacing':!$isGirlsAndSteam}"
                     :type="'search'" :name="'parentEmail'"
                     :value="parentEmail"
                     v-model="parentEmail"
                     :placeholder="parentEmailPlaceholder"
                     :center="true"
                     @enter="$refs.username.$refs.input.focus()"
                     :disabled="waiting"
                     :label="parentEmailPlaceholder"
                     :autocomplete="'off'"
                     data-lpignore="true" />

              <Input v-if="$isGirlsAndSteam"
                     ref="parentFirstName isef-spacing"
                     class="signup"
                     :type="'search'" :name="'parentFirstName'"
                     :value="parentFirstName"
                     v-model="parentFirstName"
                     :placeholder="parentFirstNamePlaceholder"
                     :center="true"
                     @enter="$refs.firstName.$refs.input.focus()"
                     :disabled="waiting"
                     :label="parentFirstNamePlaceholder"
                     :autocomplete="'off'"
                     data-lpignore="true" />

              <Input v-if="$isGirlsAndSteam"
                     ref="parentLastNamePlaceHolder isef-spacing"
                     class="signup"
                     :type="'search'" :name="'parentLastNamePlaceHolder'"
                     :value="parentLastName"
                     v-model="parentLastName"
                     :placeholder="parentLastNamePlaceHolder"
                     :center="true"
                     @enter="$refs.lastName.$refs.input.focus()"
                     :disabled="waiting"
                     :label="parentLastNamePlaceHolder"
                     :autocomplete="'off'"
                     data-lpignore="true" />
            </div>
            <!--  End update here -->
            <div class="signup-inputs" v-if="!$isIsef && !$isGirlsAndSteam && !$isBroadcomMasters && !$isSts">
              <div class="ysc-student-warning" v-if="this.$isYSC">{{ $t('modalLogin.noCode') }}</div>
              <!-- Email Input -->
              <Input ref="email"
                     class="signup"
                     :type="'search'"
                     :name="'email'"
                     :value="email"
                     v-model="email"
                     :placeholder="$t('login.email')"
                     :center="true"
                     @enter="$refs.username.$refs.input.focus()"
                     :disabled="waiting"
                     :label="$t('login.email')"
                     :autocomplete="'off'"
                     data-lpignore="true" />
              <!-- Username Input -->
              <Input ref="username"
                     class="signup"
                     :type="'search'"
                     :name="'username'"
                     :value="username"
                     v-model.trim="username"
                     :placeholder="displayUsernamePlaceholder"
                     :center="true"
                     @enter="$refs.password.$refs.input.focus()"
                     :disabled="waiting"
                     :label="displayUsernamePlaceholder"
                     :autocomplete="'off'"
                     data-lpignore="true" />
              <!-- Password Input -->
              <Input ref="password"
                     class="signup"
                     :type="'password'"
                     :name="'password'"
                     :value="password"
                     v-model.trim="password"
                     :placeholder="$t('login.choosePassword')"
                     :center="true"
                     @enter="$refs.confirmedPassword.$refs.input.focus()"
                     :disabled="waiting"
                     :label="$t('login.choosePassword')"
                     :autocomplete="'new-password'"
                     data-lpignore="true" />
              <!-- Confirm Password Input -->
              <Input ref="confirmedPassword"
                     class="signup"
                     :type="'password'"
                     :name="'confirmedPassword'"
                     :value="password"
                     v-model.trim="confirmedPassword"
                     :placeholder="$t('login.confirmPassword')"
                     :center="true" @enter="signup"
                     :disabled="waiting"
                     :label="$t('login.confirmPassword')" />
              <Input v-if="isOhioStudentRegistration"
                     ref="studentCode"
                     class="signup"
                     :type="'search'"
                     :name="'studentCode'"
                     :value="studentCode"
                     v-model="studentCode"
                     :placeholder="$t('login.classCode')"
                     :center="true"
                     @enter="$refs.username.$refs.input.focus()"
                     :disabled="waiting"
                     :label="$t('login.classCode')"
                     :autocomplete="'off'"
                     data-lpignore="true" />

              <div v-if="error && (!userNotFoundError || !invalidEmailError)" class="help has-text-danger error">{{error}}</div>
              <div v-if="showPasswordError && (!userNotFoundError || !invalidEmailError)" style="text-align: left; padding-top: 0.5rem">
                <ul class="password-check help has-text-danger error">
                  <li :class="{'success': passwordNumberCheck}">{{ $t("password.number")}}</li>
                  <li :class="{'success': passwordUppercaseCheck}">{{ $t("password.upper")}}</li>
                  <li :class="{'success': passwordLengthCheck}">{{ $t("password.length")}}</li>
                  <li :class="{'success': passwordSequencesCheck}">{{ $t("password.seq")}}</li>
                </ul>
              </div>
            </div>

            <div v-if="!isOhioClassRegistration"
                 class="third-party-buttons is-flex is-centered">
              <div v-if="showMakeOauth"
                   class="gtm-make-login other-login-button make"
                   @click="providerLogin(make(), 'make')"
                   :disabled="waiting"
                   :data-balloon="`${thirdPartyHelpPrefix} with your Make: Account`"
                   data-balloon-pos="down"><span class="icon make-icon">
                <img src="/static/makey-logo.svg" alt="Make.co logo">
              </span>
              </div>
              <div v-if="showSignInWithApple"
                   class="button is-apple gtm-apple-login other-login-button apple"
                   @click="apple"
                   :disabled="waiting"
                   :data-balloon="`${appleHelpPrefix} with Apple`"
                   data-balloon-pos="down">
                <span class="icon apple-icon">
                  <img src="/static/white-logo-masked-circular.png">
                </span>
              </div>
              <div class="button is-primary gtm-google-login other-login-button"
                   @click="providerLogin(google(), 'google')"
                   :disabled="waiting"
                   :data-balloon="`${thirdPartyHelpPrefix} with your Google Account`"
                   data-balloon-pos="down"
                   v-on:keypress.enter.space="providerLogin(google(), 'google')"
                   tabindex="0">
                <span class="icon">
                  <i class="fab fa-google"/>
                </span>
              </div>
              <div v-if="!isMobile && showSignInSMS"
                   class="button is-primary gtm-sms-login other-login-button"
                   @click="showPhone"
                   :disabled="waiting"
                   :data-balloon="`${thirdPartyHelpPrefix} via SMS`"
                   v-on:keypress.enter.space="showPhone"
                   data-balloon-pos="down"
                   tabindex="0">
                <span class="icon">
                  <i class="fas fa-phone" />
                </span>
              </div>
              <div v-if="checkAllowMicrosoftLogin" class="gtm-make-login other-login-button make"
                   @click="MicrosoftSignIn"
                   :disabled="waiting"
                   :data-balloon="`${thirdPartyHelpPrefix} with your Microsoft Account`"
                   data-balloon-pos="down"><span class="icon make-icon">
                <img src="/static/microsoft_logo.png" alt="Microsoft logo">
              </span>
              </div>
            </div>
            <p v-if="!userNotFoundError && !$isOhioScience"
               class="has-account-message"
               tabindex="0"
               v-on:keypress.space.enter="showLogin">
              {{ $t("login.haveAccount") }}<a @click="showLogin" qa="login-switch">
              {{ $t("login.login") }}</a>
            </p>
            <div v-if="!isOhioClassRegistration" class="terms-of-service"
                 tabindex="0"
                 v-on:keypress.space.enter="openTerms">{{ $t("login.agreeToTerms") }}
              <a @click="openTerms">{{ $t("login.termsLink") }}
              </a>
              <div class="terms-of-service photo-agreement" v-if="$isOhioScience"> {{ $t('signupSurvey.photoAgreement') }} </div>
            </div>
            <checkbox class="is-size-7 has-text-grey"
                      :label="$t('signupSurvey.positive')"
                      v-if="!$isIsef && !$isGirlsAndSteam && !$isBroadcomMasters && !$isSts"
                      v-model="positiveChecked" qa="mandatory-checkbox"
                      :error="error"/>
            <checkbox class="is-size-7 has-text-grey" v-if="!$isAjas && !$isIsef && !$isGirlsAndSteam && !$isBroadcomMasters && !$isSts" :label="receiveEmailsLabel" v-model="emailsChecked" qa="marketing-checkbox" :error="error"/>

            <checkbox class="is-size-7 has-text-grey"
                      :label="emailConsent"
                      v-if="showEmailConsent"
                      v-model="emailsChecked"
                      qa="marketing-checkbox"
                      :error="error"/>

            <!-- Code Of Conduct -->
            <checkbox class="is-size-7 has-text-grey"
                      :label="codeOfConduct"
                      v-if="showCodeOfConduct"
                      v-model="positiveChecked"
                      qa="mandatory-checkbox"
                      :error="error"/>
          </div>

          <div class="terms-and-signup-container">
            <div v-if="isOhioClassRegistration" class="terms-of-service spacer ohio-terms"
                 tabindex="0"
                 v-on:keypress.space.enter="openTerms">{{ $t("login.agreeToTerms-ohio") }}
              <a class="ohio-terms-a" @click="openTerms">{{ $t("login.termsLink") }}</a>
            </div>
            <div class="ohio-signup">
              <vue-recaptcha
                  ref="recaptcha"
                  @verify="signupOhio"
                  @expired="onRecaptchaExpired"
                  size="invisible"
                  :sitekey="recaptcha_sitekey">
              </vue-recaptcha>
              <button v-if="isOhioClassRegistration" class="button is-primary is-full-width continue-button"
                      :class="{'is-loading': waiting}"
                      :disabled="waiting || !checked"
                      @click="onRecaptchaButtonClicked"
                      @keydown.tab.exact=null
                      qa="signup-continue-btn">
                {{ $t("signupSurvey.signUpButton")}}
              </button>
            </div>
          </div>

          <!-- Update here for Girls And Steam-->
          <div  class="next-button-container"  style="clear:both; " v-if="!isOhioClassRegistration">
            <vue-recaptcha
                ref="recaptcha"
                @verify="signup"
                @expired="onRecaptchaExpired"
                size="invisible"
                :sitekey="recaptcha_sitekey">
            </vue-recaptcha>
            <button v-if="!isOhioClassRegistration" class="button is-primary is-full-width continue-button"
                    :class="{'is-loading': waiting}"
                    :disabled="waiting || !checked"
                    @click="onRecaptchaButtonClicked"
                    @keydown.tab.exact=null
                    qa="signup-continue-btn">
                {{ $t("signupSurvey.continueButton")}}
              </button>
          </div>
        </div>

        <!-- header -->
        <div v-if="!noMethodSelected && (!user && (loggingIn || loggingInPhone))" class="title welcome-modal" :class="{'is-eng': $isEngCom}" qa="login-modal-title">{{ $t("login.login") }}</div>
        <div v-if="!noMethodSelected && (user && !newUser)" class="title welcome-modal" :class="{'is-eng': $isEngCom}" qa="welcome-msg-username">{{ $t("login.hello") }}, {{user.userName}}</div>
        <div v-if="!noMethodSelected && newUser" class="title welcome-modal" :class="{'is-eng': $isEngCom}" qa="check-inbox-msg">{{ $t("checkInbox") }}</div>

        <div v-if="loggingIn && !usingPassword && !usingVerificationCode && !noMethodSelected" class="container">
          <div class="field full-width">
            <div class="control make-projects">
              <!-- Log In Input -->
              <Input ref="signin"
                     class="signup"
                     :type="'text'"
                     :name="'email'"
                     :value="email"
                     v-model.trim="email"
                     :placeholder="$t('login.signInEmail')"
                     :center="true"
                     @enter="checkUser"
                     :disabled="waiting"
                     :label="signInPlaceholder"
                     :autocomplete="'username'"/>
              <div v-if="error && (!userNotFoundError || !invalidEmailError)" class="help has-text-danger error">{{error}}</div>
              <div v-if="error && (oauthError) && showMakeOauth" class="help error">{{ $t('credentialsLogin-1') }} <a @click="make"><strong>Make:</strong></a> {{ $t('credentialsLogin-2') }}? <br> Click <a @click="make"><strong>here</strong></a>!</div>
            </div>
          </div>
          <div v-if="!$isOhioScience" class="third-party-buttons is-flex is-centered">
            <div tabindex="0" v-if="showMakeOauth" class="gtm-make-login other-login-button make" @click="make" :disabled="waiting" :data-balloon="`${thirdPartyHelpPrefix} with your Make: Account`" data-balloon-pos="down"><span class="icon make-icon"><img src="/static/makey-logo.svg" alt="Make.co logo"></span></div>
            <div tabindex="0" v-if="showSignInWithApple" class="button is-apple gtm-apple-login other-login-button apple" @click="apple" :disabled="waiting" :data-balloon="`${appleHelpPrefix} with Apple`" data-balloon-pos="down"><span class="icon apple-icon"><img src="/static/white-logo-masked-circular.png"></span></div>
            <div tabindex="0" class="button is-primary gtm-google-login other-login-button" @click="providerLogin(google(), 'google')" :disabled="waiting" :data-balloon="`${thirdPartyHelpPrefix} with your Google Account`" data-balloon-pos="down"><span class="icon"><i class="fab fa-google"></i></span></div>
            <div tabindex="0" v-if="!isMobile && showSignInSMS" class="button is-primary gtm-sms-login other-login-button" @click="showPhone" :disabled="waiting" :data-balloon="`${thirdPartyHelpPrefix} via SMS`" data-balloon-pos="down"><span class="icon"><i class="fas fa-phone"></i></span></div>
            <div v-if="checkAllowMicrosoftLogin" class="gtm-make-login other-login-button make" @click="MicrosoftSignIn" :disabled="waiting" :data-balloon="`${thirdPartyHelpPrefix} with your Microsoft Account`" data-balloon-pos="down"><span class="icon make-icon"><img src="/static/microsoft_logo.png" alt="Microsoft logo"></span></div>
          </div>

          <p v-if="showSignupCheck" class="has-account-message">{{ $t("login.new")}} <a
              @click="showSignup"
              tabindex="0"
              @keypress.space.enter="showSignup"
              qa="signup-switch">
            {{ $t("login.signUp")}}
          </a></p>
          <p v-if="showSignupLink && $isOhioScience && !this.$route.query.userType" class="has-account-message">{{ $t("login.new") }}
            <a
              @click="gotoOhioSignup"
              tabindex="0"
              @keypress.space.enter="gotoOhioSignup"
              qa="signup-switch">
            {{ $t("login.signUpOhio.1") }}
          </a>
            {{ $t("login.signUpOhio.2") }}
          </p>
          <p v-if="$isOasam && !this.$route.query.userType" class="has-account-message">{{ $t("login.new") }}
            <a
                @click="gotoOhioSignup"
                tabindex="0"
                @keypress.space.enter="gotoOhioSignup"
                qa="signup-switch">
              {{ $t("login.signUpOasam.1") }}
            </a>
            {{ $t("login.signUpOasam.2") }}
          </p>

          <footer>
            <a class="button continue-button is-primary is-full-width"
               :class="{'is-loading': waiting}"
               tabindex="0"
               @keypress="checkUser"
               @click="checkUser"
               :disabled="waiting"
               qa="login-next-btn">
              {{$t('next') }}
            </a>
          </footer>
        </div>

        <div v-if="usingVerificationCode" class="container">
          <div v-if="!$isGirlsAndSteam" class="subtitle">
            <p qa="verification-code-msg"> {{ sentCode }} <br><b>{{ email || defaultEmailMessage }}</b><br>{{$t('login.checkSpam')}}</p>
          </div>
          <div v-if="$isGirlsAndSteam" class="subtitle">
            <p> {{ sentCode }} <br><b>{{ email || defaultEmailMessage }}</b><br>{{checkSpamMessage}}<br><b>{{gsSecondPartMessage}}</b></p>
          </div>
          <div v-if="!usingDoubleOptIn" class="field full-width">
            <div class="control">
              <!-- Verification Input -->
              <Input class="signup"
                     :type="'text'"
                     :name="'verification'"
                     :value="code"
                     v-model="code"
                     :placeholder="$t('login.verification')"
                     :center="true" @enter="login"
                     :disabled="waiting" :label="$t('login.verification')" :qa="'vrf-code-field'" />
              <div v-if="error" class="help has-text-danger error">{{error}}</div>
            </div>
          </div>
          <div v-if="!usingDoubleOptIn"
               class="button continue-button is-primary is-full-width"
               :class="{'is-loading': waiting}"
               @click="login"
               :disabled="waiting"
               tabindex="0"
               @keypress.space.enter="login"
               qa="submit-vrf-code-btn">{{ $t('signupSurvey.continueButton') }}</div>
          <div class="lower gtm-try-again">
            <p>{{ $t('login.didntGet') }}<a tabindex="0"
                                            @keypress.enter.space="sendVerificationCode"
                                            @click="sendVerificationCode"> {{ $t('login.tryAgain') }}</a></p>
            <div v-if="newUser" class="links gtm-try-again">
              <div v-if="!$isYSC && !$isStories" class="try-again-container">
                <div class="student-email-message">* {{ $t('signup-modal.student-code') }}</div>
              </div>
              <div v-if="$isYSC" class="try-again-container">
                <div class="student-email-message">* {{ $t('signup-modal.student-teacher-code') }}</div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="usingPassword" class="container">
          <div class="field full-width">
            <div class="control">
              <!-- Password Input -->
              <Input ref="password" class="signup make-projects" :type="'password'" :name="'password'" :value="password" v-model="password" :placeholder="$t('modalLogin.enterPassword')" :center="true" @enter="login" :disabled="waiting" :label="$t('modalLogin.enterPassword')" />
              <input type="hidden" name="username" v-model="username" :disabled="waiting" />
              <div v-if="error" class="help has-text-danger error">{{error}}</div>
            </div>
          </div>
          <div class="button using-password-button is-primary is-full-width"
               :class="{'is-loading': waiting}"
               @click="login"
               @keypress.enter.space="login"
               tabindex="0"
               :disabled="waiting"
               qa="login-btn">{{$t("modalLogin.login")}}</div>
          <div class="lower">
            <div>{{$t('modalLogin.forgetPassword')}}</div>
            <div class="links">
              <div><a @click="resetPassword" qa="reset-pwd-link">{{$t("modalLogin.resetPassword")}}&nbsp;|&nbsp;</a></div>
              <div class="login-link-button is-flex"><a @click="sendVerificationCode" class="gtm-magiclink" qa="vrf-code-link">{{$t("modalLogin.emailLink")}}</a> <span class="icon is-small tip" :data-balloon="$t('modalLogin.receiveLink')" data-balloon-pos="up"><i class="fal fa-question-circle"></i></span></div>
            </div>
          </div>
        </div>

        <div v-if="sentResetPasswordLink" class="container">
          <div class="subtitle">{{$t("login.emailMsg")}}</div>
          <div class="lower">
            <b><div>{{$t("login.getIt")}}<a @click="resetPassword">{{$t('login.sendAgain')}}</a></div></b>
          </div>
        </div>

        <phone v-if="usingPhone" :done="close" :trackConversionInFacebook="trackConversionInFacebook" :goBack="goBackSMS" @newUser="newUserCreated"></phone>

        <div v-if="createPassword" class="container">
          <div class="signup-inputs" qa="new-pwd-inputs">
            <!-- Password Input -->
            <Input ref="createPassword" class="signup" :type="'password'" :name="'password'" :value="password" v-model.trim="password" :placeholder="passwordPlaceholder" :center="true" @enter="$refs.confirmedCreatePassword.$refs.input.focus()" :disabled="waiting || doNotPromptForPassword" :label="passwordPlaceholder" :autocomplete="'new-password'" data-lpignore="true" />
            <!-- Confirm Password Input -->
            <Input ref="confirmedCreatePassword" class="signup" :type="'password'" :name="'confirmedPassword'" :value="password" v-model.trim="confirmedPassword" :placeholder="confirmPasswordPlaceholder" :center="true" @enter="savePassword" :disabled="waiting || doNotPromptForPassword" :label="confirmPasswordPlaceholder" />
            <div v-if="error && (!userNotFoundError || !invalidEmailError)" class="help has-text-danger error">{{error}}</div>
            <div v-if="showPasswordError && (!userNotFoundError || !invalidEmailError)" style="text-align: left; padding-top: 0.5rem">
              <ul class="password-check help has-text-danger error">
                <li :class="{'success': passwordNumberCheck}">{{ $t("password.number")}}</li>
                <li :class="{'success': passwordUppercaseCheck}">{{ $t("password.upper")}}</li>
                <li :class="{'success': passwordLengthCheck}">{{ $t("password.length")}}</li>
                <li :class="{'success': passwordSequencesCheck}">{{ $t("password.seq")}}</li>
              </ul>
            </div>
          </div>
          <!-- Commenting out instead of deleting, so we can bring this back when needed -->
          <!--checkbox class="is-size-7 has-text-grey" :label="$t('password.doNotPrompt')" v-model="doNotPromptForPassword" :error="error"/-->
          <div>
            <div class="button is-primary is-full-width continue-button" :class="{'is-loading': waiting}" :disabled="!createPasswordContinue" @click="savePassword">{{ $t("signupSurvey.continueButton")}}</div>
          </div>
        </div>
      </section>
      <!-- Modal Trapping Section -->
      <div aria-hidden="true"
           @focus="selectFirstElement()"
           tabindex="0" />
      <!-- Modal Tappring Ends -->
    </aside>
  </div>
</template>

<script>
import users from '@/api/users'
import auth from '@/libs/auth'
import firebase from '@/libs/firebase'
import { VueRecaptcha } from 'vue-recaptcha'
import Phone from '@/components/Forms/PhoneLogin/Phone'
import userAgent from '@/libs/user-agent'
import PasswordStrength from '@fnando/password_strength'
import link from '@/mixins/link'
import signup from '@/mixins/signup'
import localStorage from 'store'
import i18n from '@/i18n'
import debounce from 'lodash/debounce'
import Checkbox from '@/components/Controls/Checkbox'
import Input from '@/components/Controls/Input'
import Dropdown from '@/components/Controls/GenericComponents/dropdown'
import componentState from '@/mixins/component-state'
import gaTrackingMixin from '@/mixins/ga-tracking'
import jwtDecode from 'jwt-decode'
import setYear from '@/mixins/set-year'
import userTypes from '@/mixins/user-types'
import urlLib from '@/libs/url'

import * as msal from '@azure/msal-browser'
export default {
  components: {
    Phone,
    Checkbox,
    Input,
    Dropdown,
    i18n,
    VueRecaptcha
  },
  mixins: [componentState, link, signup, gaTrackingMixin, userTypes, setYear],
  data: function () {
    return {
      active: false,
      view: 4, // this.viewStart, viewStart is undefined at this point so hard coding 4 :(
      email: '',
      username: '',
      password: '',
      occupation: '',
      numStudents: '',
      parentEmail: '',
      parentFirstName: '',
      parentLastName: '',
      confirmedPassword: '',
      code: '',
      user: null,
      hasPassword: false,
      hasPhone: false,
      newUser: false,
      error: '',
      showPasswordError: false,
      passwordNumberCheck: false,
      passwordUppercaseCheck: false,
      passwordLengthCheck: false,
      passwordSequencesCheck: false,
      waiting: false,
      linkAccount: null,
      firebaseToken: null,
      userVerified: false,
      preventCategoriesModal: false, // true if we have already selected categories: clicked personalize button
      isFollow: false, // true if we click a bookmark if not signed in. Redirects to homepage,
      positiveChecked: false,
      emailsChecked: false,
      redirectParam: '',
      defaultEmailMessage: i18n.t('login.emailAccount'),
      emailPlaceholder: i18n.t('login.email'),
      parentEmailPlaceholder: i18n.t('login.parentEmail'),
      parentFirstNamePlaceholder: i18n.t('login.parentFirstName'),
      parentLastNamePlaceHolder: i18n.t('login.parentLastName'),
      companyNamePlaceholder: i18n.t('login.chooseCompanyUsername'),
      passwordPlaceholder: i18n.t('login.choosePassword'),
      confirmPasswordPlaceholder: i18n.t('login.confirmPassword'),
      signInPlaceholder: i18n.t('login.signInEmail'),
      newUserSignUp: i18n.t('login.newUser'),
      verification: i18n.t('login.verification'),
      didntGet: i18n.t('login.didntGet'),
      tryAgain: i18n.t('login.tryAgain'),
      checkSpamMessage: i18n.t('login.checkSpam'),
      gsSecondPartMessage: i18n.t('login.gsSecondStep'),
      recaptcha_sitekey: process.env.RECAPTCHA_SITE_KEY,
      registerReasonError: false,
      gasStep: false,
      occupationError: false,
      numStudentsError: false,
      isStudent: false,
      isCwsfUser: false,
      isCwsfViewer: false,
      cwsfLandingCheckboxError: false,
      userRole: {
        student: false,
        visitor: false
      },
      canClose: true,
      doNotPromptForPassword: false,
      occupations: ['Student', 'Educator', 'Parent', 'Science Professional', 'Other'],
      myMsalObj: {},
      microsoftClientId: '',
      showStudentCode: false,
      enterStudentCode: i18n.t('login.studentcode'),
      studentCode: '',
      showStudentSignUp: false,
      studFirstName: '',
      studLastName: '',
      studUsername: '',
      firstName: '',
      lastName: '',
      teacherUId: 0,
      groupId: 0,
      className: ''
    }
  },
  watch: {
    active: function (active) {
      if (active) {
        this.refreshLoginModal()
      }
      this.login(active)
      this.toggleScrolling(active)
      this.checkRedirectParam()
    },
    keyName: function (key) {
      this._setObjectKey(key)
    },
    '$i18n.locale': function () {
      this.$store.dispatch('updateSelectedLanguage', this.$i18n.locale)
    },
    doNotPromptForPassword: function () {
      this.password = ''
      this.confirmedPassword = ''
    }
  },
  computed: {
    appName: function () {
      return process.env.APP_NAME.toLowerCase()
    },
    showSignupCheck: function () {
      if (this.$isOhioScience) {
        return this.isOhioStudentRegistration || this.isOhioTeacherRegistration || this.isOhioMentor
      } else {
        return this.$isIsef || this.$isGirlsAndSteam || this.showSignupLink
      }
    },
    displayUsernamePlaceholder: function () {
      if (this.$route.query.userType && (this.$route.query.userType).toLowerCase() === 'stemexpo') {
        return this.companyNamePlaceholder
      }
      return this.usernamePlaceholder
    },
    usernamePlaceholder: function () {
      return i18n.t('login.chooseUsername')
    },
    allowMakeAuth: function () {
      return this.appName === 'Make'
    },
    modalData: function () {
      return this.$store.getters.modalData('login') || {}
    },
    signupSource: function () {
      if (this.$isApp) {
        const source = this.$route.params.to ? this.$route.params.to.query.utm_source : this.$route.query.utm_source
        if (source) {
          return this.formatSource(source)
        }
      }

      if (this.modalData.source) {
        return this.formatSource(this.modalData.source)
      }

      return ''
    },
    title: function () {
      if (this.modalData.source === 'feedback-survey') {
        return 'Thanks for your feedback!'
      }
      if (this.isResourceSignUp) {
        return 'Resource Sign Up'
      }
      if (this.isOhioClassRegistration) {
        return 'https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/ohiosci%2FProjectboardxOhio.png?alt=media'
      }

      return i18n.t('login.signUp')
    },
    showEmailConsent: function () {
      return this.$isIsef || this.$isGirlsAndSteam || this.$isBroadcomMasters || this.$isSts
    },
    emailConsent: function () {
      if (this.$isIsef) {
        return i18n.t('signup-modal.isef-opt-out')
      } else if (this.$isGirlsAndSteam) {
        return i18n.t('signup-modal.girls-and-steam-opt-out')
      } else if (this.$isBroadcomMasters) {
        return i18n.t('signup-modal.societyforsciencebcm-opt-out')
      } else if (this.$isSts) {
        return i18n.t('signup-modal.sts-opt-out')
      }
    },
    showCodeOfConduct: function () {
      return this.$isIsef || this.$isGirlsAndSteam || this.$isBroadcomMasters || this.$isSts
    },
    codeOfConduct: function () {
      if (this.$isIsef) {
        return i18n.t('signup-modal.isef-code-of-conduct-1') + i18n.t('signup-modal.isef-code-of-conduct-2')
      } else if (this.$isBroadcomMasters) {
        return i18n.t('signup-modal.societyforsciencebcm-code-of-conduct-1') +
            i18n.t('signup-modal.societyforsciencebcm-code-of-conduct-2') + i18n.t('signup-modal.societyforsciencebcm-code-of-conduct-3')
      } else if (this.$isSts) {
        return i18n.t('signup-modal.sts-code-of-conduct-1') +
            i18n.t('signup-modal.sts-code-of-conduct-2') + i18n.t('signup-modal.sts-code-of-conduct-3')
      } else {
        return i18n.t('signup-modal.girls-and-steam-code-of-conduct-1') +
            i18n.t('signup-modal.girls-and-steam-code-of-conduct-2') + i18n.t('signup-modal.isef-code-of-conduct-3')
      }
    },
    isResourceSignUp: function () {
      return this.modalData.source === 'resource-signUp'
    },
    referralCode: function () {
      return auth.getReferralCode() || ''
    },
    noMethodSelected: function () {
      return this.view === this.viewStart
    },
    usingPassword: function () {
      return this.view === this.viewPassword
    },
    usingVerificationCode: function () {
      return this.view === this.viewVerificationCode
    },
    usingPhone: function () {
      return this.view === this.viewPhoneLogin || this.view === this.viewPhoneSignup
    },
    sentResetPasswordLink: function () {
      return this.view === this.viewResetPassword
    },
    loggingIn: function () {
      return this.view === this.viewLogin
    },
    loggingInPhone: function () {
      return this.view === this.viewPhoneLogin
    },
    signingUpPhone: function () {
      return this.view === this.viewPhoneSignup
    },
    createPassword: function () {
      return this.view === this.viewCreatePassword
    },
    userNotFoundError: function () {
      if (this.$isIsef) {
        if (this.error === 'User not found') {
          return this.userNotFoundErrorMessageIsef()
        }
      }
      return this.error === 'User not found'
    },
    oauthError: function () {
      return this.error === ' '
    },
    invalidEmailError: function () {
      return this.error === i18n.t('error.invalid.email')
    },
    thirdPartyHelpPrefix: function () {
      return this.loggingIn ? 'Log in' : 'Sign up'
    },
    appleHelpPrefix: function () {
      return this.loggingIn ? 'Continue with' : 'Sign in'
    },
    isApp: userAgent.isApp,
    signupMessage: function () {
      return this.modalData.signupMessage || ''
    },
    defaultMessage: function () {
      if (this.$isEngCom) {
        i18n.t('signup-modal.sign-up')
      }
      return 'Sign up to create private or public projects,\nask questions, or workshop ideas with fellow makers!'
    },
    isMobile: function () {
      return userAgent.isApp() || userAgent.isIOS() || userAgent.isAndroid()
    },
    checked: function () {
      return this.positiveChecked
    },
    usingDoubleOptIn: function () {
      return this.$isHeise && this.newUser
    },
    sentCode: function () {
      return this.usingDoubleOptIn ? i18n.t('login.sentLink') : i18n.t('login.sentCode')
    },
    receiveEmailsLabel: function () {
      if (this.$isEngCom) {
        return i18n.t('signupSurvey.receiveEmailsNewEng')
      } else if (this.$isProjectboard) {
        return i18n.t('signupSurvey.receiveBoardEmails')
      } else if (this.$isYSC) {
        return i18n.t('signupSurvey.receiveEmailsYsc')
      } else {
        return i18n.t('signupSurvey.receiveEmails')
      }
    },
    showMakeOauth: function () {
      return this.$isMake
    },
    makeOauthErrorString: function () {
      const prefix = this.$isAjas ? 'Cannot ' : ''
      return prefix + this.$t('error.invalid.useMakeLogin')
    },
    signUpWelcomeMessage: function () {
      if (this.$isAjas) {
        return this.$t('signup-modal.ajas-welcome-1') + this.currentYear + this.$t('signup-modal.ajas-welcome-2')
      } else if (this.$isIsef || this.$isGirlsAndSteam || this.$isBroadcomMasters || this.$isSts) {
        return this.$t('signup-modal.under-13-message')
      } else if (this.$isStories) {
        return this.$t('signup-modal.sign-in')
      }
    },
    clientId: function () {
      if (process.env.APP_NAME === 'Make') {
        return 'com.engineering.projectboard.app.service'
      } else if (process.env.APP_NAME === 'Neweng') {
        return 'com.engineering.app.service'
      }
      return ''
    },
    utmYsc: function () {
      const utm = auth.getUtmSource()
      return utm === 'login_from_ysc_portal' && this.$isYSC
    },
    showSignInWithApple: function () {
      return (process.env.APP_NAME === 'Make' || process.env.APP_NAME === 'Neweng') && (userAgent.isMacOS() || userAgent.isIOS())
    },
    showSignInSMS: function () {
      return !(process.env.APP_NAME === 'Neweng')
    },
    showSignupUtm: function () {
      return this.$route.query.signup
    },
    showSignupLink: function () {
      // Temporarily adding isOasam due to client - pulseID 3573561608
      return this.showSignupUtm || (!this.utmYsc && !this.$isIsef && !this.$isOasam)
    },
    createPasswordContinue: function () {
      return (this.password !== '' && this.confirmedPassword !== '') || this.doNotPromptForPassword
    },
    isJudgeRegistration: function () {
      return this.$route.query.userType === this.UserTypeJudge
    },
    isOhioStudentRegistration: function () {
      return this.$isOhioScience && this.$route.query.userType === this.UserTypeStudent
    },
    isOhioTeacherRegistration: function () {
      return this.$isOhioScience && this.$route.query.userType === this.UserTypeTeacher
    },
    // Both Teacher and Student
    isOhioClassRegistration: function () {
      return this.isOhioStudentRegistration || this.isOhioTeacherRegistration
    },
    isOhioMentor: function () {
      return this.$route.query.userType === this.UserTypeMentor
    },
    showWelcomeMessage: function (value) {
      return 'Welcome To Login' + value
    },
    loginRequest: function () {
      const loginRequest = {
        scopes: ['openid', 'profile', 'User.Read']
      }
      return loginRequest
    },
    tokenRequest: function () {
      const tokenRequest = {
        scopes: ['User.Read', 'Mail.Read']
      }
      return tokenRequest
    },
    domain: function () {
      return process.env.WEB_ROOT
    },
    studentGroup: function () {
      return this.$store.getters.teacherGroup
    },
    checkAllowMicrosoftLogin: function () {
      return this.domain.includes('https://projectboard.world') || this.domain.includes('https://pbworld.stagepb.com') || this.domain.includes('http://localhost')
    },
    shouldShowYscPreRegistrationModal: function () {
      return this.$isYSC && !this.isJudgeRegistration && !this.showStudentCode
    }
  },
  mounted: function () {
    this.refreshLoginModal()
    this.canClose = this.$route.query.close !== 'false'
    const clientId = this.$microsoftClientId
    const microConfig = {
      auth: {
        clientId: clientId,
        authority: 'https://login.microsoftonline.com/common',
        redirectUri: process.env.WEB_ROOT
      },
      cache: {
        cacheLocation: 'sessionStorage', // This configures where your cache will be stored
        storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
        secureCookies: false
      },
      system: {
        loggerOptions: {
          loggerCallback: (level, message, containsPii) => {
            if (containsPii) {
              return
            }
            switch (level) {
              case msal.LogLevel.Error:
                console.error(message)
                return
              case msal.LogLevel.Info:
                console.info(message)
                return
              case msal.LogLevel.Verbose:
                console.debug(message)
                return
              case msal.LogLevel.Warning:
                console.warn(message)
            }
          }
        }
      }
    }
    this.myMsalObj = new msal.PublicClientApplication(microConfig)
    const accounts = this.myMsalObj.getAllAccounts()
    if (accounts.length > 0) {
      this.account = accounts[0]
      this.$emit('login', this.account)
    }
    this.verifyAndRedirect()
    if (this.showSignInWithApple) {
      // eslint-disable-next-line no-undef
      AppleID.auth.init({
        clientId: this.clientId,
        scope: 'name email',
        redirectURI: `${process.env.API_ROOT}/apple/redirect`,
        state: this.state(),
        nonce: this.state(),
        usePopup: true // or false defaults to false
      })
    }
  },
  methods: {
    refreshLoginModal: function () {
      if (this.active) {
        // short circuit this modal if it's already completed (on refresh)
        if (this.$store.getters.loggedIn) {
          this.$nextTick(() => {
            this.close(true)
          })
        }
      }
    },
    selectFirstElement: function () {
      this.$refs.first_element.focus()
    },
    cwsfOccupationSelected: function () {
      this.numStudentsError = false
      this.numStudents = ''
    },
    userNotFoundErrorMessageIsef: function () {
      this.error = 'User not found. Please contact the Society at isef@societyforscience.org'
    },
    showModal: function () {
      this.active = true
      this.show()
      this.checkIfPersonalize()
    },
    openTerms: function () {
      if (this.$isOhioScience) {
        window.open(i18n.t('ohioScience.consentFormLink'), '_blank')
      } else {
        const routeData = this.$router.resolve({ name: 'terms' })
        window.open(routeData.href, '_blank')
      }
    },
    isUsername: function () {
      return this.email.indexOf('@') === -1
    },
    show: function () {
      this.toggleIOS11Fix(true)
      this.reset()
      if (!this.isMobile) {
        if (this.view === this.viewStart) {
          this.$nextTick(() => { this.$refs.email.$refs.input.focus() })
        } else {
          this.$nextTick(() => { this.$refs.signin.$refs.input.focus() })
        }
      }
      this.checkIfLoggedIn()
    },
    close: async function (success, data) {
      if (!success && this.$route.path.includes('/blankpage')) {
        if (!this.$isOasam) {
          await this.$router.push({ name: 'home' })
        } else {
          await this.$router.push({ name: 'landingRedirect' })
        }
      }
      this.active = false
      this.toggleIOS11Fix(false)
      !success && this.$store.dispatch('resourceButtonClicked', false)
      const modalData = this.$store.getters.modalData('login')
      if (modalData && modalData.follow) {
        this.isFollow = modalData.follow
      }

      if (auth.isLoggedIn && this.$isYSC) {
        if (!this.newUser) {
          this._callback('checkUserLanguage')
        } else {
          const languageSetting = localStorage.get('language')
          if (languageSetting) {
            const settings = { language: languageSetting }
            this.$store.dispatch('updateUserSettings', { username: this.$store.getters.currentUser.userName, settings })
          }
        }
      }

      if (this.$isYSC) {
        this.isStudent = false
        this.userRole.cwsfViewer = false
        this.userRole.cwsfUser = false
        this.userRole.student = false
        this.userRole.visitor = false
        this.occupation = ''
        this.numStudents = ''
        this.numStudentsError = false
        this.notSelectedError = false
      } else if (this.$isGirlsAndSteam) {
        this.isStudent = false
        this.gasStep = true
        this.userRole.cwsfViewer = false
        this.userRole.cwsfUser = false
        this.userRole.student = false
        this.userRole.visitor = false
        this.occupation = ''
        this.numStudents = ''
        this.numStudentsError = false
        this.notSelectedError = false
      }
      this.$emit('modalDone', success, this.newUser)
      this.reset()
    },
    reset: function () {
      if (this.modalData.source === 'LOGIN:{PATH}' || this.modalData.source === 'STORY-MODAL' || this.modalData.signup === true || this.$isCnmiIwsf) {
        this.view = this.viewStart
      } else {
        this.view = this.viewLogin
      }
      this.email = ''
      this.username = ''
      this.password = ''
      this.confirmedPassword = ''
      this.code = ''
      this.user = null
      this.hasPassword = false
      this.hasPhone = false
      this.newUser = false
      this.error = ''
      this.showPasswordError = false
      this.passwordNumberCheck = false
      this.passwordUppercaseCheck = false
      this.passwordLengthCheck = false
      this.passwordSequencesCheck = false
      this.firebaseToken = null
      this.redirectParam = ''
    },
    checkUser: function () {
      if (this.view === this.viewPassword) {
        return
      }

      if (this.email.length === 0) {
        this.error = 'Please input an email or username'
        return
      }

      const data = {
        username: '',
        email: this.email
      }

      if (this.isUsername()) {
        data.username = this.email
        this.username = this.email
        data.email = ''
        // Could get email from database and use {{email}} on line 60
      }

      this.error = ''
      this.waiting = true
      this.$store.dispatch('preAuth', data).then((response) => {
        this.email = data.email
        if (response.isOAuth && this.showMakeOauth) {
          this.waiting = false
          this.error = this.makeOauthErrorString
          if (!this.$isAjas) {
            this.providerLogin(this.make(), 'make')
          }
          return
        }
        this.user = response.user
        this.hasPassword = response.hasPassword
        this.hasPhone = response.hasPhone
        this.doNotPromptForPassword = response.user.UserSettings.doNotPromptForPassword
        if (!response.isVerified) {
          if (this.hasPhone && !this.hasPassword) {
            this.showPhone()
            // send a code to their phone in database
          } else if (this.hasPhone && this.hasPassword) {
            this.view = this.viewPassword
            this.$nextTick(() => { this.$refs.password.$refs.input.focus() })
          } else {
            // when the user reaches here, it they are not verified and don't have a password. This scenario is not
            // possible for our sign ups. For the regular sign up, we always will have a password. Social media users
            // don't use this flow and the phone users have a condition in the first block. This should be uncommented.
            this.sendVerificationCode()
          }
        } else {
          if (this.hasPassword) {
            this.view = this.viewPassword
            this.$nextTick(() => { this.$refs.password.$refs.input.focus() })
          } else {
            this.sendVerificationCode()
          }
        }
        this.waiting = false
      }, (error) => {
        this.waiting = false
        this.error = error.message
      })
    },
    sendVerificationCode: function () {
      if (this.email.length === 0 && this.username.length === 0) {
        return
      }
      this.error = ''
      this.waiting = true
      const params = { email: this.email, username: this.username, doubleOptIn: this.usingDoubleOptIn, redirect: this.redirectParam }
      this.$store.dispatch('preAuth', { username: this.username, email: this.email }).then((response) => {
        this.hasPhone = response.hasPhone
        if (this.hasPhone) {
          this.showPhone()
          // Send a text to their phone in database with login link
        } else {
          this.$store.dispatch('login', params).then((user) => {
            this.view = this.viewVerificationCode
            this.user = user
          }, (error) => {
            this.error = error.message
          })
        }
        this.waiting = false
      }, (error) => {
        this.waiting = false
        this.error = error.message
        this.email = ''
        this.username = ''
      })
    },
    toggleScrolling: function (active) {
      if (this.$route.name !== 'blankPage') {
        active ? this._callback('lockScrolling', false) : this._callback('unlockScrolling', true)
      }
    },
    login: function () {
      if (this.usingPassword) {
        return this.loginWithPassword()
      }

      if (this.usingVerificationCode) {
        return this.loginWithVerificationCode()
      }
    },
    loginWithPassword: function () {
      if (!this.password) {
        this.error = 'Please enter your password'
        return
      }
      this.error = ''
      this.waiting = true
      this.$store.dispatch('login', { username: this.user.userName, password: this.password }).then((tokens) => {
        this.trackSigninSuccessful('native-password')
        auth.storeTokens(tokens)
        this.close(true)
        this.waiting = false
      }, (error) => {
        this.waiting = false
        this.error = error.message
      })
    },
    loginWithVerificationCode: function () {
      this.error = ''
      this.waiting = true
      this.$store.dispatch('isSigningUp', true)
      this.$store.dispatch('verify', this.code).then((tokens) => {
        if (this.newUser) {
          this.trackSignupVerified('native')
        } else {
          this.trackSigninSuccessful('native-verificationCode')
          this.$store.dispatch('setUtmSignupMethod', { signupMethod: 'native' })
        }
        auth.storeTokens(tokens)
        this.hasPassword = this.$store.getters.hasPassword
        if (!this.hasPassword && !this.doNotPromptForPassword) {
          this.canClose = false
          this.waiting = false
          this.view = this.viewCreatePassword
        } else {
          this.userVerified = true
          this.close(true)
          this.waiting = false
        }
        const settings = { language: this.$store.getters.getSelectedLanguage }
        this.$store.dispatch('updateUserSettings', { username: this.$store.getters.currentUser.userName, settings })
      }, (error) => {
        this.waiting = false
        this.error = error.message
      })
    },
    resetPassword: function () {
      this.error = ''
      this.waiting = true
      users.resetPassword(this.user.userName).then(() => {
        this.view = this.viewResetPassword
        this.waiting = false
      }, (error) => {
        this.waiting = false
        this.error = error.message
      })
    },
    showSignup: function () {
      this.error = ''
      this.view = this.viewStart
    },
    gotoOhioSignup: function () {
      const routeData = this.$router.resolve('/')
      window.open(routeData.href, '_self')
    },
    showLogin: function () {
      if (this.username.length > 0) {
        this.email = ''
        this.username = ''
      }
      this.error = ''
      this.view = this.viewLogin
    },
    trackConversionInFacebook: function () {
      if (window.fbq) {
        window.fbq('track', 'CompleteRegistration')
      }
    },
    similarity: function (s1, s2) {
      if (s1.length <= s2.length) {
        return (s2.length - this.strDistance(s2, s1)) / s2.length
      } else {
        return (s1.length - this.strDistance(s1, s2)) / s1.length
      }
    },
    strDistance: function (s1, s2) {
      const dist = []
      let lastValue
      let newValue

      for (let i = 0; i <= s1.length; i++) {
        lastValue = i

        for (let j = 0; j <= s2.length; j++) {
          if (i === 0) {
            dist[j] = j
          } else if (j > 0) {
            newValue = dist[j - 1]

            if (s1.charAt(i - 1) !== s2.charAt(j - 1)) {
              newValue = Math.min(Math.min(newValue, lastValue), dist[j]) + 1
            }

            dist[j - 1] = lastValue
            lastValue = newValue
          }
        }

        if (i > 0) {
          dist[s2.length] = lastValue
        }
      }

      return dist[s2.length]
    },
    checkSequencesAndRepetitions: function (text) {
      let matches = 0
      let sequenceSize = 0
      const codes = []
      const len = text.length
      let previousCode, currentCode

      for (let i = 0; i < len; i++) {
        currentCode = text.charCodeAt(i)
        previousCode = codes[codes.length - 1]
        codes.push(currentCode)

        if (previousCode) {
          if (currentCode === previousCode + 1 || previousCode === currentCode) {
            sequenceSize += 1
          } else {
            sequenceSize = 0
          }
        }

        if (sequenceSize === 2) {
          matches += 1
        }
      }

      return matches
    },
    checkClassCode: function () {
      if (this.studentCode.length !== 0) {
        if (!isNaN(this.studentCode)) {
          return true
        } else {
          this.error = 'Class code must be a number'
          return false
        }
      }
      this.error = 'Please enter the class code'
      return false
    },
    checkPassword: function () {
      const uppercase = /[A-Z]/
      const number = /[0-9]/
      const strength = PasswordStrength.test('', this.password)
      if (!this.createPassword) {
        if (this.email.length === 0) {
          this.error = 'Please input an email address'
          return false
        } else if (this.email.indexOf('@') < 1 || this.email.lastIndexOf('.') < this.email.indexOf('@') + 2 || this.email.lastIndexOf('.') + 2 >= this.email.length) {
          this.error = this.$t('error.invalid.email')
          return false
        }
      }
      if (this.username.length === 0 || !this.username) {
        this.error = 'Please choose a username'
        return false
      } else if (this.password.length === 0) {
        this.error = 'Please choose a password'
        return false
      } else if (this.password.length < 6 || !uppercase.test(this.password) || !number.test(this.password) || strength.status === 'weak' || strength.status === 'invalid' || strength.score === 0) {
        if (number.test(this.password)) {
          this.passwordNumberCheck = true
        }
        if (uppercase.test(this.password)) {
          this.passwordUppercaseCheck = true
        }
        if (this.password.length >= 6) {
          this.passwordLengthCheck = true
        }
        if (strength.status !== 'weak' && strength.status !== 'invalid' && strength.score > 0) {
          this.passwordSequencesCheck = true
        }
        this.showPasswordError = true

        if (this.checkSequencesAndRepetitions(this.password)) {
          this.error = 'Avoid using repeating or consecutive characters is misleading. '
        } else {
          this.error = 'Your password is too weak'
        }
        return false
      } else if (this.similarity(this.username.toLowerCase(), this.password.toLowerCase()) >= 0.7) {
        this.error = 'Password is too similar to your username'
        return false
      } else if (this.confirmedPassword.length === 0) {
        this.error = 'Please confirm your password'
        return false
      } else if (this.password !== this.confirmedPassword) {
        this.error = 'Passwords do not match! Please try again'
        return false
      }

      return true
    },
    signupOhio: function (recaptchaToken) {
      if (this.isOhioStudentRegistration) {
        this.signupOhioStudent(recaptchaToken)
      } else {
        this.signup(recaptchaToken)
      }
    },
    signupOhioStudent: function (recaptchaToken) {
      if (this.checkClassCode()) {
        this.$store.dispatch('getGroupByCode', this.studentCode).then((group) => {
          if (group && group.id !== 0 && (this.studentCode === group.code)) {
            this.teacherUId = group.userId
            this.groupId = group.id
            this.className = group.name
            this.signup(recaptchaToken)
          } else {
            this.error = 'Class code is invalid'
          }
        })
      }
    },
    signup: function (recaptchaToken) {
      this.error = null
      if (!this.positiveChecked) {
        this.error = 'You must agree to the disclaimer below to continue'
        return
      }
      this.view = this.viewStart
      this.showPasswordError = false
      this.passwordNumberCheck = false
      this.passwordUppercaseCheck = false
      this.passwordLengthCheck = false
      this.passwordSequencesCheck = false

      if (this.$isIsef) {
        // ISEF: Checked means they want to opt out
        this.emailsChecked = !this.emailsChecked
      }

      if (this.checkPassword()) {
        let userType = 'standard'
        if (this.$route.query.userType) {
          userType = this.$route.query.userType
        }
        this.error = ''
        this.waiting = true
        this.$refs.recaptcha.reset()
        const params = {
          email: this.email,
          username: this.username,
          password: this.password,
          signupSource: this.signupSource,
          referralCode: this.referralCode,
          skipSignupSurvey: this.$isStories,
          receiveEmails: this.emailsChecked,
          redirectParam: this.redirectParam,
          sendVerification: true,
          userType: userType,
          userOccupation: this.$route.query.userType,
          PreferredLanguage: this.$i18n.locale,
          recaptchaToken: recaptchaToken
        }

        this.trackSignupInitial('native')
        this.$store.dispatch('setUtmSignupMethod', { signupMethod: 'native' })
        this.$store.dispatch('signup', params).then((user) => {
          if (this.isOhioStudentRegistration) {
            const data = {
              groupId: this.groupId,
              teacherUId: this.teacherUId,
              userId: user.id,
              className: this.className
            }
            this.$store.dispatch('createGroupUser', data).then((response) => {
              this.response = response
            })
          }

          if (this.$isIsef) {
            if (this.parentEmail !== '') {
              const partnerUserInfo = {
                infoName: '2021 ISEF: Parent Email for Students 14-16',
                infoValue: this.parentEmail
              }
              this.$store.dispatch('addPartnerUserInfo', { username: user.userName, partnerUserInfo }).then((response) => {
                this.response = response
              })
            }
          }

          if (this.$isGirlsAndSteam) {
            this.canClose = false
            if (this.parentFirstName !== '' && this.parentLastName !== '' && this.parentEmail !== '') {
              const parentDataItems = [
                {
                  infoName: 'Girls and STEAM: Parent email',
                  infoValue: this.parentEmail
                },
                {
                  infoName: 'Girls and STEAM: Parent first name',
                  infoValue: this.parentFirstName
                },
                {
                  infoName: 'Girls and STEAM: Parent last name',
                  infoValue: this.parentLastName
                }
              ]
              parentDataItems.map((parentItem) => {
                this.$store.dispatch('addPartnerUserInfo', {
                  username: user.userName, partnerUserInfo: parentItem
                }).then((response) => {
                  this.response = response
                }, (error) => {
                  this.error = error.message
                })
              })
            }
            // Reset the parameters
            this.parentEmail = ''
            this.parentFirstName = ''
            this.parentLastName = ''
          }

          if (this.$isIsef || this.$isYSC) {
            const profile = {
              occupation: this.occupation
            }
            this.$store.dispatch('updateProfileOccupation', { username: user.userName, profile }).then((response) => {
              this.user = response.user
            })
          }

          if (this.$isYSC && this.occupation === 'Teacher' && this.numStudents !== '') {
            const partnerUserInfo = {
              infoName: new Date().getFullYear() + ' CWSF: Number of Students',
              infoValue: this.numStudents
            }
            this.$store.dispatch('addPartnerUserInfo', { username: user.userName, partnerUserInfo }).then((response) => {
              this.response = response
            })
          }
          this.newUser = true
          if (!this.$isOhioScience && !this.$isOasam) {
            this.view = this.viewVerificationCode
          } else {
            this.$store.dispatch('login', { username: this.username, password: this.password }).then((tokens) => {
              auth.storeTokens(tokens)
              this.close(true)
            }, (error) => {
              this.waiting = false
              this.error = error.message
            })
          }
          this.waiting = false
          this.trackConversionInFacebook() // track only successful conversions
        }, (error) => {
          if (error.status === 409) { // conflict => already exists
            return this.checkUser()
          }
          this.waiting = false
          this.error = error.message
        })
      }
    },
    checkIfLoggedIn: function () {
      if (!this.active) {
        return
      }

      if (this.isloggedIn) {
        this.close(true)
      } else {
        setTimeout(() => { this.checkIfLoggedIn() }, 3000)
      }
    },
    formatSource: function (source) {
      source = typeof source !== 'string' ? '{PATH}' : source
      source = source.replace('{PATH}', this.$route.fullPath)

      if (source.indexOf('utm_source') < 0) {
        const utmSource = auth.getUtmSource('utm_source')
        if (utmSource) {
          source = `${source} utm_source=${utmSource}`
        }
      }

      return source
    },
    showPhone: function () {
      this.trackSignupInitial('phone')
      this.$store.dispatch('setUtmSignupMethod', { signupMethod: 'phone' })
      if (this.isApp) {
        window.open(`${this.$webRoot}/login/sms/${this.signingUp ? 'signup' : ''}`)
        document.addEventListener('appURLReceived', (event) => {
          if (event.detail && event.detail.path === 'sms') {
            if (event.detail.data && event.detail.data.token) {
              this.firebaseToken = event.detail.data.token
              this.firebaseLogin()
            }
          }
          document.removeEventListener('appURLReceived')
        }, false)
      } else {
        this.view = this.loggingIn ? this.viewPhoneLogin : this.viewPhoneSignup
      }
    },
    google: function () {
      return new firebase.auth.GoogleAuthProvider()
    },
    facebook: function () {
      return new firebase.auth.FacebookAuthProvider()
    },
    make: function () {
      if (!this.isApp) {
        window.open(`${process.env.API_ROOT}/oauth/login`, '_blank', 'location=0,status=0,width=1200,height=800')
        window.addEventListener('message', event => {
          if (event.origin === process.env.WEB_ROOT) {
            this.makeCallback(event.data)
          }
        })
      } else {
        // eslint-disable-next-line no-undef
        const popup = cordova.InAppBrowser.open(`${process.env.API_ROOT}/oauth/login`, '_blank', 'location=0')
        popup.addEventListener('message', event => {
          this.makeCallback(event.data)
          popup.close()
        })
      }
    },
    makeCallback: function (data) {
      const that = this
      let response
      if (!this.isApp) {
        response = JSON.parse(data)
      } else {
        response = data
      }
      this.$store.dispatch('makeLogin', response).then(function (tokens) {
        auth.storeTokens(tokens)
        that.waiting = false
        if (response.created) {
          that.newUser = true
        } else if (!response.created && that.$route.path === '/blankpage') {
          that.$router.push({ path: '/start/template', query: that.$route.query })
        }
        that.close(true)
      })
    },
    apple: function () {
      if (!this.isApp) {
        // eslint-disable-next-line no-undef
        AppleID.auth.signIn().then(
          data => this.signInWithApple(data.authorization.id_token, data.user), error => console.error(error)
        )
      }
    },
    signInWithApple: function (idToken, user) {
      const token = jwtDecode(idToken)

      if (user && user.firstName !== '' && user.lastName !== '') {
        // apple sends the user property only for the first time. so we need to sign them up
        this.error = ''
        this.waiting = true
        const params = {
          email: token.email,
          password: 'P' + token.sub,
          first_name: user.firstName,
          last_name: user.lastName,
          source: 'apple',
          skipSignupSurvey: this.$isStories,
          receiveEmails: true,
          redirectParam: this.redirectParam
        }
        this.$store.dispatch('signup', params).then((user) => {
          this.newUser = true
          this.view = this.viewVerificationCode
          this.user = user
          this.waiting = false
          this.trackConversionInFacebook() // track only successful conversions
        }, (error) => {
          if (error.status === 409) { // conflict => already exists
            return this.checkUser()
          }
          this.waiting = false
          this.error = error.message
        })
      } else {
        // log user in
        this.$store.dispatch('preAuth', { email: token.email }).then((response) => {
          this.$store.dispatch('login', {
            username: response.user.userName,
            password: 'P' + token.sub
          }).then((tokens) => {
            auth.storeTokens(tokens)
            this.close(true)
            this.waiting = false
          }, (error) => {
            this.waiting = false
            this.error = error.message
          })
          this.waiting = false
        }, (error) => {
          this.waiting = false
          this.error = error.message
          this.email = ''
          this.username = ''
        })
      }
    },
    state: function () {
      const validChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let array = new Uint8Array(40)
      window.crypto.getRandomValues(array)
      array = array.map(x => validChars.charCodeAt(x % validChars.length))
      return String.fromCharCode.apply(null, array)
    },
    providerLogin: function (provider, providerName) {
      this.error = ''

      let signIn = null
      if (this.isApp) {
        signIn = firebase.auth().signInWithRedirect(provider).then(() => {
          return firebase.auth().getRedirectResult()
        })
      } else {
        signIn = firebase.auth().signInWithPopup(provider)
      }

      this.trackSignupInitial(providerName)
      this.$store.dispatch('setUtmSignupMethod', { signupMethod: providerName })
      signIn.then((response) => {
        this.checkProviderLoginResponse(response, providerName)
      }).catch((err) => {
        if (err.code === 'auth/account-exists-with-different-credential' || auth.code === 'auth/email-already-in-use') {
          firebase.auth().fetchProvidersForEmail(err.email).then((providers) => {
            this.linkAccount = { email: err.email, credential: err.credential }
            this.error = `Please login with your ${providers[0]} account first to link your account.`
          })
        } else if (err.code !== 'auth/popup-closed-by-user') {
          this.error = 'An unexpected error occurred. Please try again.'
        }
      })
    },
    checkProviderLoginResponse: function (response, providerName) {
      if (!response.user.email) {
        this.error = 'An email address is required to sign-in.'
        response.user.delete()
        return
      }

      this.firebaseLogin(providerName)

      if (this.linkAccount && response.user.email === this.linkAccount.email) {
        response.user.linkWithCredential(this.linkAccount.credential)
      }
    },
    firebaseLogin: function (providerName) {
      this.error = ''
      this.waiting = true
      this.getFirebaseToken().then((token) => {
        const data = {
          idToken: token,
          signupSource: this.signupSource,
          referralCode: this.referralCode,
          skipSignupSurvey: this.$isStories
        }

        this.$store.dispatch('firebaseLogin', data).then((response) => {
          auth.storeTokens(response.tokens)
          this.user = response.user
          this.newUser = response.newUser
          if (response.newUser) {
            if (providerName && this.view !== this.viewLogin) {
              this.trackSignupVerified(providerName)
            }
            this.newUser = true
            if (this.$isEngCom && this.preventCategoriesModal) {
              this.$store.dispatch('showCategoryModal', { source: 'login' })
            }
          } else {
            this.trackSigninSuccessful(providerName)
            this.$store.dispatch('trackUserSignup')
          }
          this.close(true)
          this.waiting = false
          if (response.newUser) {
            this.trackConversionInFacebook()
          }
        }, (error) => {
          this.waiting = false
          this.error = error.message
        })
      })
    },
    getFirebaseToken: function () {
      return new Promise((resolve) => {
        if (this.firebaseToken) {
          return resolve(this.firebaseToken)
        }

        firebase.auth().currentUser.getIdToken().then((token) => {
          this.firebaseToken = token
          resolve(token)
        })
      })
    },
    goBackSMS: function () {
      if (this.signingUpPhone) {
        this.reset()
      } else {
        this.showLogin()
      }
    },
    checkIfPersonalize: function () {
      const modalData = this.$store.getters.modalData('login')
      if (modalData && modalData.selectedCategories) {
        this.preventCategoriesModal = true
      }
    },
    newUserCreated: function () {
      this.newUser = true
    },
    checkRedirectParam: function () {
      const hasRedirect = this.$route.query.redirect
      if (hasRedirect) {
        this.redirectParam = this.$route.query.redirect
      }
    },
    verifyAndRedirect: debounce(async function () {
      const isLoginRoute = (this.$route.name === 'login')
      const hasToken = (this.$route.query.token)
      const username = (this.$route.query.username)
      const hasRedirect = (this.$route.query.redirect)

      if (isLoginRoute) {
        if (hasToken) {
          try {
            const response = await this.$store.dispatch('verifyToken', { token: hasToken, username })
            auth.storeTokens(response.tokens)
            if (urlLib.isValid(this.$route.query.redirect)) {
              window.location = this.$route.query.redirect
            } else {
              this.$router.push({ name: (hasRedirect && hasRedirect !== '') ? hasRedirect : 'home' })
            }
            this.checkShowSurvey()
          } catch (err) {
            this.$store.dispatch('addErrorNotification', 'Unable to log in. Please try again.')
          }
        } else if (hasRedirect) {
          this.checkFablabsLinkClick()
          if (urlLib.isValid(this.$route.query.redirect)) {
            window.location = this.$route.query.redirect
          } else {
            this.$router.push({ name: hasRedirect })
          }
        }
      }
    }, 500),
    checkShowSurvey: function () {
      const isNewUser = (this.$route.query.new === 'true')
      const isFablabsCompetition = (this.$route.query.redirect === 'fablabsthankyou')

      if (isNewUser) {
        this.$store.dispatch('showSignupSurvey', { type: isFablabsCompetition ? 'fablabs' : null })
      } else if (isFablabsCompetition) {
        this.$router.push({ name: 'fablabstemplate' })
      }
    },
    checkFablabsLinkClick: function () {
      const linkclick = (this.$route.query.redirect === 'fablabstemplate')
      linkclick && users.saveFablabsLinkClick({ linkclick })
    },
    onChildClick (value) {
      this.userRole = value
    },
    savePassword: function () {
      this.error = ''
      this.showPasswordError = false
      if (this.doNotPromptForPassword) {
        // do not prompt the user to set the password again
        const settings = { doNotPromptForPassword: this.doNotPromptForPassword }
        this.$store.dispatch('updateUserSettings', { username: this.user.userName, settings }).then(() => {
          this.waiting = false
          this.canClose = true
          this.close(true)
        })
      } else {
        // validate password and save it
        this.username = this.user.userName
        if (this.checkPassword()) {
          // save the password
          const params = { username: this.user.userName, password: this.password }
          this.$store.dispatch('createPassword', params).then(() => {
            this.waiting = false
            this.canClose = true
            this.close(true)
          }, (err) => {
            this.error = err
          })
        }
      }
    },
    handleResponse: function (response) {
      if (response !== null) {
        if (response.account.username !== '') {
          // apple sends the user property only for the first time. so we need to sign them up
          this.error = ''
          this.waiting = true
          this.email = response.account.username
          const params = {
            email: response.account.username,
            password: response.account.idTokenClaims.sub,
            fullName: response.account.name,
            redirectParam: this.redirectParam,
            source: 'microsoft',
            receiveEmails: true
          }
          this.$store.dispatch('signupByMicrosoft', params).then((user) => {
            this.newUser = true
            this.userVerified = true
            this.user = user
            this.loginWithMicrosoft(response)
            this.waiting = false
            this.close(true)
          }, (error) => {
            if (error.status === 409) { // conflict => already exists
              this.loginWithMicrosoft(response)
              this.waiting = false
              this.close(true)
            }
          })
        } else {
          this.loginWithMicrosoft(response)
        }
      }
    },
    MicrosoftSignIn: function () {
      this.myMsalObj.loginPopup(this.loginRequest).then(this.handleResponse).catch(error => {
        console.error(error)
      })
    },
    loginWithMicrosoft: function (response) {
      this.$store.dispatch('login', {
        email: response.account.username,
        password: response.account.idTokenClaims.sub,
        loginSource: 'Microsoft'
      }).then((tokens) => {
        auth.storeTokens(tokens)
      }, (error) => {
        this.waiting = false
        this.error = error.message
      })
    },
    checkStudentCodeInDB: function () {
      this.error = null
      this.$store.dispatch('getGroupByCode', this.studentCode).then((group) => {
        if (group && group.id !== 0) {
          this.teacherUId = group.userId
          this.error = null
          this.showStudentSignUp = true
        } else if (group === null) {
          this.waiting = false
          this.error = 'The code entered does not exist. Please try again.'
        }
      })
    },
    onRecaptchaButtonClicked: function () {
      this.$refs.recaptcha.execute()
    },
    onRecaptchaVerified: function (recaptchaToken) {
      this.$refs.recaptcha.reset()
      // this.studentSignUpByCode(recaptchaToken)
    },
    onRecaptchaExpired: function () {
      this.$refs.recaptcha.reset()
    },
    studentSignUpByCode: function (recaptchaToken) {
      this.waiting = true
      const params = {
        firstName: this.studFirstName,
        lastName: this.studLastName,
        userName: this.studUsername,
        email: 'teachercode+' + this.studUsername + '@projectboard.com',
        redirectParam: this.redirectParam,
        signupSource: 'TeacherCode',
        teacherUId: this.teacherUId,
        recaptchaToken: recaptchaToken
      }
      this.$store.dispatch('signup', params).then((user) => {
        const params = {
          groupId: this.studentGroup.id,
          teacherUId: this.studentGroup.userId,
          userId: user.id,
          className: this.studentGroup.name
        }
        this.$store.dispatch('createGroupUser', params).then((response) => {
        }, (error) => {
          this.waiting = false
          this.error = error.message
        })
        this.newUser = true
        this.userVerified = true
        this.user = user
        this.loginWithTeacherCode()
        this.waiting = false
        this.close(true)
      }, (error) => {
        this.waiting = false
        this.error = error.message
      })
    }
  }
}

</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

$modal-body-color: #F2F2F2;
$modal-footer-color: #F7F7F7;
$close-icon-color: #1A051D;
$border-color: #DCDCDC;
$placeholder-font-color: #565656;
$input-background-color: #FFFFFF;
$input-height: 40px;
$bottom-message-font-color: #3F3F3F;

.terms-and-signup-container {
  width: 70%;
  margin: 1rem auto;
  overflow: hidden;
}

.ohio-terms {
  float: left;
}
.ohio-signup {
  float: right;
}

.numStudents {
  width: 3.5rem;
  font-size: 1rem;
}

.left {
  text-align: left;
}
.center {
  text-align: center;
  margin-left: -60%;
  padding: 1rem 0 5px 0;
@include mobile {
  margin-left: -50%;
}
}
.occupation {
  margin-left: 36%;
@include mobile {
  margin-left: 30%;
}
}
.isef-spacing {
  margin-bottom: 1.5rem;
}

.modal {
  z-index: 50;
}

.modal-card {
  background: $modal-body-color;
  padding: 1.3rem 0 0;
  text-align: center;
  overflow: auto;
@include mobile {
  max-width: 98vw;
}
}

.close {
  top: 0.4rem;
  right: 1rem;
  position: absolute;
  font-size: 1.5rem;
  color:  $close-icon-color;
  border: none;
  padding: 0;
  background: transparent;
&:hover {
   color: $link-hover;
 }
}

.make-login {
  margin: 0.7rem 0 0.4rem;
  text-align: center;
}

.apple-login {
  margin: 0.7rem 0 0.4rem;
  text-align: center;
}

.section {
  height: auto;
  padding: 0;

.container {
  margin: auto;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  width: 500px;
@include mobile {
  width: 300px;
  max-width: 300px;
}
@media screen and (max-height: 375px) {
  margin-top: auto;
}
}
}

.title {
  font-family: $primary-font;
  font-weight: $primary-font-weight;
@include mobile{
  font-size: 1.75rem;
}
}

.title-img {
  width: 70%;
}

.subtitle {
  width: inherit;
  color: #4A4A4A;
  margin: 0;
  padding: 1.5rem 0;
  font-size: 0.9rem;
  line-height: 1.4rem;
}

.full-width {
  width: 100%;
}

.button {
  border-radius: 0;
  padding: 1rem 1.5rem;
  text-transform: uppercase;
  font-size: 0.9rem;
&.continue-button {
   margin: 1.1rem 0 1.1rem;
   padding: 1.15rem 1.2rem;
 }
&.using-password-button {
   margin: 0 0 1.5rem;
 }
}
.button[disabled] {
  pointer-events: none;
}

.is-apple {
  background-color: transparent;
  border-color: transparent;
  color: black;
}

// Google, Facebook, and Mobile Buttons
.third-party-buttons {
     width: 100%;
     padding-bottom: 1rem;
     justify-content: center;
.button {
  padding: 0;
  width: 2.5rem;
  height: 2.5rem;
  text-transform: capitalize;
.icon {
  font-size: 1.3rem;
}
.make-icon {
  height: 2.5rem;
  width: 2.5rem;
img {
  width: 100%;
}
}
.apple-icon {
  height: 2.5rem;
  width: 2.5rem;
img {
  width: 100%;
}
}
.fa-facebook-f {
  font-size: 1.4rem;
}
.fa-phone {
  margin-bottom: 1px;
}
}
}

.lower {
  padding-bottom: 3rem;
  font-size: .75rem;
}

.links {
  display:flex;
@include mobile{
  font-size: 0.8rem;
}
}

.tip {
  cursor: pointer;
@include mobile {
  display: none;
}
}

.occupationError {
  margin-top: 0.5rem;
  color: red;
  height: 2rem;
}

.cwsfLandingCheckboxError {
  margin-top: 1rem;
  color: red;
  height: 2rem;
}

.notSelectedError {
  color: red;
  height: 2rem;
}

.error {
  text-align: center;
}

.help.error {
  color: #EA002A;
}

.password-check {
  list-style-type: none;
  padding-left: 0.8rem;
  color: #FF3860;

li:before {
  content: "\2715";
  padding-right: 0.5rem;
}

li.success {
  color: green;
}

li.success:before {
  content: "\2713";
  padding-right: 0.5rem;
}
}

.try-again-container{
  display: flex;
  flex-direction: column;
  width: 100%;
.student-email-message {
  padding-top: 2rem;
}
}

.login-link-button {
  align-items: center;
span {
  margin-left: 0.3rem;
}
}

.welcome-modal {
  border-bottom: 1px solid $border-color;
  padding-bottom: 1.3rem;
}

.signup {
  margin-top: 0.5rem;
}
.control {
&.make-projects {
   margin: 2.4rem 0 1.4rem;
 }
}

.other-login-button {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  border-radius: 50%;
  justify-content: center;
.make-icon {
  height: 2.5rem;
  width: 2.5rem;
}
&:hover {
   background-color: $link-hover;
 }
.make {
&:hover {
   background-color: transparent !important;
 }
.icon {
  height: 2rem;
  width: 2rem
}
}
.apple {
&:hover {
   background-color: transparent !important;
 }
.icon {
  height: 2rem;
  width: 2rem
}
}
}
.make {
&:hover {
   background-color: transparent;
 }
}
.apple {
&:hover {
   background-color: transparent;
 }
}

.terms-of-service {
  font-family: 'Roboto';
  font-weight: 300;
  font-size: 0.9rem;
  padding: 0.3rem 0 0.5rem;
a {
  color: #373737;
  text-decoration: underline;
&:hover {
   color: $link-hover;
 }
@include mobile {
  display: block;
}
}
}

.spacer {
  margin-top: 1em;
}
.ysc-student-warning {
  font-family: 'Roboto';
  font-weight: 300;
  font-size: 0.9rem;
}

.code-of-conduct {
a {
  color: #373737 !important;
  text-decoration: underline !important;
}
}

.next-button-container {
  margin: 0.5rem 0 0;
  width: 100%;
  background-color: $modal-footer-color;
@include mobile {
  margin: 0;
}
}

.writeup {
  font-size: 0.9rem;
  padding:1.7rem 0 2.1rem;
  width: inherit;
  font-family: $primary-font;
}

.has-account-message {
  color: $bottom-message-font-color;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.pre-formatted {
  white-space: pre;
}

.signup-inputs {
  padding-bottom: 1rem;
  width: inherit;
input[type=search] {
  padding-left: 20px;
}
input[type=password] {
&::-webkit-credentials-auto-fill-button {
   width: 0px;
   height: 0px;
   margin: 0;
   display: none !important; // This should work, but because of the way the webkit auto fill button is designed, its own important overwrites this.
 }
}
@include mobile {
  padding-bottom: 1rem;
}
}

.welcome-modal.title {
  font-size: 1.5rem;
  margin-bottom: 0;
}

input[placeholder] {
  text-overflow: ellipsis;
  overflow: hidden;
}
.checks {
  padding-top: 5px;
}

.redirect-message {
  top: 0px;
  position: relative;
  padding-bottom: 1rem;
}

.ysc-questions {
  padding-bottom: 9px;
  padding-top: 12px;
  display: flex;
  flex-direction: column;
  font-size: 16px !important;
}

.signup-reason {
  color: $bottom-message-font-color;
  font-weight: 500;
  margin-top: -10px;
  font-size: 1.07rem;
}

#student-checkbox, #visitor-checkbox {
  left: 70px;
  height: 0px;
}
.handle-checkboxes {
  display: flex;
  width: 100%;
  font-size:1.06rem
}
.weight-spacing {
  margin-left: 4rem;
  font-weight: 400;
}

.cwsfExpeienceNotesTitle {
  text-align: left;
  padding-left: 1rem;
}

ul.cwsfExperienceNotes {
  padding-left: 20%;
  list-style: disc;
  text-align: left;
}
.cwsf-parent-container {
  width: 100%;
  display: flex;
  justify-content: center;
::v-deep .checkboxes {
  width: 100% !important;
}
}
.cwsf-container {
  width: 100%;
.handle-checkboxes {
  margin-bottom: 1rem;
}
.cwsfExperienceNotes li{
  margin-bottom: 0.10rem;
  margin-top: 0.10rem;
}
.cwsfExperienceNotes{
  display: flex;
  justify-content: center;
  flex-direction: column;
  list-style-position: inside;
}
.cwsfTitle{
  margin-bottom: 0.5rem;
  font-weight: bold;
}
}

.photo-agreement {
  font-size: 0.9rem;
  max-width: 425px;
  padding: 0;
}

@media screen and (max-width: 767px) {
  .terms-and-signup-container {
    width: 70%;
  }
  .terms-of-service a {
    display: inline-block;
  }
  .ohio-terms {
    float: left;
    width: 67%;
  }
}

@media screen and (max-width: 684px) {
  .terms-and-signup-container {
    width: 85%;
  }
  .ohio-terms {
    float: left;
    width: 68%;
  }
}

@media screen and (max-width: 555px) {
  .ohio-terms {
    width: 71%;
  }
}
@media screen and (max-width: 532px) {
  .terms-and-signup-container {
    width: 85%;
  }
  .ohio-terms {
    width: 72%;
  }
}

@media screen and (max-width: 524px) {
  .terms-and-signup-container {
    width: 85%;
  }
  .ohio-terms {
    width: 73%;
  }
}

@media screen and (max-width: 517px) {
  .terms-and-signup-container {
    width: 90%;
  }
  .ohio-terms {
    width: 71%;
  }
}
@media screen and (max-width: 502px) {
  .terms-and-signup-container {
    width: 92%;
  }
  .ohio-terms {
    width: 72%;
  }
}

</style>
<style lang="scss">
body.ios-modal-fix {
  position: fixed;
}
</style>
